<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useOrderStore } from '../../../stores/orderForm';
import { getAllUsers } from '../../../dataProviders/user';
import useDataQuery from '../../../composables/useDataQuery';
import type { Order } from '../../../types/Order';

const orderStore = useOrderStore();
const { order, adminView } = storeToRefs(orderStore);
const { data: usersData, isLoading: usersLoading } = useDataQuery({ query: getAllUsers, uniqueKey: 'listUsers', placeholder: [], useCache: true });

const user = computed(() => {
  if ('user_id' in order.value) {
    return usersData.value?.find(item => item.id === (order.value as Order).user_id);
  }
  return undefined;
});
</script>

<template>
  <Fieldset v-if="adminView" v-loading="usersLoading" :pt="{ legend: 'bg-gray-200 border border-gray-300 hover:bg-gray-300' }">
    <template #legend>
      <div class="align-items-center flex gap-2 px-2">
        <span class="font-bold">Потребител</span>
        <i class="pi pi-user !leading-[unset]" />
      </div>
    </template>

    <div v-if="user" class="mb-6 pd-form-cols-3">
      <FormItem
        field="name"
        :label="$t('profile.form.name')"
        disabled
        :model-value="user.info.name"
      />
      <FormItem
        field="invoicingName"
        :label="$t('profile.form.invoicingName')"
        disabled
        :model-value="user.invoicing.name"
      />
      <FormItem
        field="phone"
        :label="$t('profile.form.phone')"
        disabled
        :model-value="user.info.phone"
      />
      <FormItem
        field="city"
        :label="$t('profile.form.city')"
        disabled
        :model-value="user.info.city"
      />
      <FormItem
        field="email"
        :label="$t('profile.form.email')"
        disabled
        :model-value="user.email"
      />
      <FormItem
        field="created_at"
        :label="$t('orders.table.created_at')"
        disabled
      >
        <Calendar
          v-model="(order as Order).created_at"
          date-format="dd.mm.yy"

          hour-format="24"
          class="w-full"
          disabled
          show-time
        />
      </FormItem>
    </div>
  </Fieldset>
</template>
